import ErrorPage from '../components/Errors/404';
import AuthWrapper from '../components/Wrappers/AuthWrapper';
import PagesWithoutTabs from '../components/Wrappers/PagesWithoutTabs';
const PageNotFound = () => {
    return (
        <AuthWrapper>
            {
                <PagesWithoutTabs isNavBarExpanded={false}>
                    <ErrorPage></ErrorPage>
                </PagesWithoutTabs>
            }
        </AuthWrapper>
    );
};

export default PageNotFound;
